import React from "react";
import moment from "moment";
import locale from "@bonliva-crm/locale";
import { Typography, Paper } from "@material-ui/core";

type Props = {
  createdOn?: Date;
  createdBy?: string;
  updatedOn?: Date;
  updatedBy?: string;
  deletedOn?: Date;
  deletedBy?: string;
};

export function Audit(props: Props) {
  const renderSection = (action, date: Date, name: string) => {
    const _date = moment.utc(date).format("llll");

    return (
      <div>
        <Typography variant="body2" align="right">
          {locale.AuditRecordByOn(action, name, _date)}
        </Typography>
      </div>
    );
  };

  return (
    <Paper elevation={0} style={{ padding: 16 }}>
      {props.createdOn && renderSection(locale.Created, props.createdOn, props.createdBy)}
      {props.updatedOn && renderSection(locale.Updated, props.updatedOn, props.updatedBy)}
      {props.deletedOn && renderSection(locale.Deleted, props.deletedOn, props.deletedBy)}
    </Paper>
  );
}
